export const rotaChecklist = [
  {
    path: "/e/checklist",
    name: "Ocorrências",
    component: () => import("@/views/Produto/Checklist/EvidenciasChecklist.vue"),
    title: "Ocorrências",
    meta: {
      title: "Ocorrências",
      showMenu: false,
    },
  },
];
